import SiafLiteApiRepository from "../../external/siafLiteApi";

class InsumosService {
  constructor() {
    this.urlBase = "/estoque/insumos";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  upsert(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/upsert`).post(body);
  }
}

export default InsumosService;
